/*
 *   Copyright (c) 2020 BuserNet Consulting LLC
 *   All rights reserved.
 */

/* This factory will store all the audit data that will be sent to server
  in case or error log
*/
import utilityService from './utility.service';
import WeatherConst from '../constants/weather.constant';

const weatherImgService = () => {
  const content = {};
  content.imageMap = {};
  content.imageMapBlack = {};
  content.loadImagesObjMap = () => {
    const keys = Object.keys(WeatherConst.weatherMapping);
    keys.forEach((item) => {
      const imageObj = new window.Image();
      imageObj.src = utilityService.getWeatherFilePath(
        WeatherConst.weatherMapping[item].filename,
        true,
      );
      content.imageMap[WeatherConst.weatherMapping[item].filename] = imageObj;

      const imageObjBlack = new window.Image();
      imageObjBlack.src = utilityService.getWeatherFilePath(
        WeatherConst.weatherMapping[item].filename,
        false,
      );
      content.imageMapBlack[WeatherConst.weatherMapping[item].filename] = imageObjBlack;
    });
    const imageObj = new window.Image();
    imageObj.src = utilityService.getWeatherFilePath('noweather-white', true);
    content.imageMap.none = imageObj;
  };
  return content;
};
export default weatherImgService();
